import classNames from "classnames";
import CurrencyInputComponent, {
  CurrencyInputProps as CurrencyComponentInputProps,
} from "react-currency-input-field";
import { TextInputProps } from "../../ui-kit/TextInput/TextInput";
import textInputStyles from "../../ui-kit/TextInput/TextInput.module.css";
import styles from "./CurrencyInput.module.css";

interface CurrencyInputProps extends TextInputProps {
  currencySymbol: string;
  intlConfig?: CurrencyComponentInputProps["intlConfig"];
}

const CurrencyInput = ({
  currencySymbol,
  onChangeText,
  value,
  placeHolder,
  error,
  nativeRef,
  ariaDescribedBy,
  ariaInvalid,
  ...rest
}: CurrencyInputProps) => {
  const onChange = (value: string | undefined) => onChangeText(value ?? "");

  return (
    <div className={classNames(styles.currencyWrapper)}>
      <CurrencyInputComponent
        decimalsLimit={0}
        className={classNames(
          textInputStyles.input,
          error && textInputStyles.inputError
        )}
        value={value}
        onValueChange={onChange}
        placeholder={placeHolder}
        ref={nativeRef}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
        {...rest}
      />
      <span className={classNames(styles.currencyCode)}>{currencySymbol}</span>
    </div>
  );
};

export default CurrencyInput;
